export interface IColumnOption {
  key: string;
  label: string;
  mandatory: boolean;
  defaultSelected: boolean;
}

export const registrationColumns: IColumnOption[] = [
  // Mandatory columns (always included, shown first)
  {
    key: "owner_last_name",
    label: "Owner Last Name",
    mandatory: true,
    defaultSelected: true
  },
  {
    key: "owner_first_name",
    label: "Owner First Name",
    mandatory: true,
    defaultSelected: true
  },
  {
    key: "call_name",
    label: "Call Name",
    mandatory: true,
    defaultSelected: true
  },
  {
    key: "arm_number",
    label: "Arm Number",
    mandatory: true,
    defaultSelected: true
  },
  // Optional columns
  {
    key: "registered_name",
    label: "Registered Name",
    mandatory: false,
    defaultSelected: false
  },
  {
    key: "breed",
    label: "Breed",
    mandatory: false,
    defaultSelected: false
  },
  {
    key: "registration_number",
    label: "Reg. #",
    mandatory: false,
    defaultSelected: false
  },
  {
    key: "owner_phone",
    label: "Owner Phone",
    mandatory: false,
    defaultSelected: false
  },
  {
    key: "owner_email",
    label: "Owner Email",
    mandatory: false,
    defaultSelected: false
  },
  {
    key: "owner_address",
    label: "Owner Address",
    mandatory: false,
    defaultSelected: false
  },
  {
    key: "owner_city",
    label: "Owner City",
    mandatory: false,
    defaultSelected: false
  },
  {
    key: "owner_state",
    label: "Owner State",
    mandatory: false,
    defaultSelected: false
  },
  {
    key: "owner_zip",
    label: "Owner Zip",
    mandatory: false,
    defaultSelected: false
  },
  {
    key: "owner_country",
    label: "Owner Country",
    mandatory: false,
    defaultSelected: false
  }
];

